import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { IconButton } from '@material-ui/core';
import { Check, Clear } from '@material-ui/icons';
import { TextField } from '../../common/components';

const S = {
  Wrapper: styled.div`
    display: flex;
    align-items: center;
  `,
  TextField: styled(TextField)`
    margin: 0 8px 0 0;
    width: 100%;
  `,
  IconButton: styled(IconButton)`
    padding: 4px;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.palette.grey[100]};
    :hover {
      background-color: ${({ theme }) => theme.palette.grey[300]};
    }
    :last-child {
      margin-left: 4px;
    }
  `,
};

const QuestionTitleField = ({
  value, onChange, onClear, onUpdate,
}) => (
  <S.Wrapper>
    <S.TextField margin="dense" value={value} onChange={onChange} />
    <S.IconButton type="button" size="small" onClick={onUpdate}>
      <Check />
    </S.IconButton>
    <S.IconButton type="button" size="small" onClick={onClear}>
      <Clear />
    </S.IconButton>
  </S.Wrapper>
);

QuestionTitleField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default QuestionTitleField;
